<template>
  <div class="main text-left">
    <div class="form-group">
      <label class="text-muted small">メールアドレス <span class="text-danger">*必須</span><br>
      <small>下記のメールアドレス宛に確認コードを送信します。</small>
      </label>
      <input type="email" class="form-control form-control-sm" v-model="input.email2" :required="true" :maxlength="50" v-bind:readonly="sendmail">
    </div>
    <button type="button" class="btn btn-warning btn-sm" v-if="!sendmail" v-on:click="send()">送信する</button>
    <div class="form-group">
      <label class="text-muted small" v-if="sendmail">確認コード入力 <span class="text-danger">*必須</span><br>
      <small>メールに記載されている「確認コード」を入力してください。</small>
      </label>
      <input type="text" class="form-control form-control-sm" v-if="sendmail" v-model="input.authcode" holder="半角数字4桁" :required="true" :maxlength="4">
    </div>
    <span class="btn btn-warning btn-sm" v-if="sendmail" v-on:click="save()">確定する</span>
  </div>
</template>
<script>
import sx from '../utils/core.js'
import vl from '../utils/validate.js'

export default {
  data() {
    return {
      input: {
        email2: this.$store.state.userinfo.email2,
        authcode: ''
      },
      sendmail: false
    }
  },
  created () {
    this.$store.state.title = '連絡用メールアドレス'
    this.$store.state.showBack = true
    this.$store.state.pageBack = 'My'
  },
  destroyed () {
    this.$store.state.showBack = false
  },
  methods: {
    toLogin() {
      this.$router.replace({ name: 'Login' })
    },
    send() {
      const that = this
      if (!sx.isNothingOrEmpty(that.input.email2)) {
        if (!vl.isEmail(that.input.email2)) {
          sx.toastError('メールアドレスが不正です！')
          return;
        }
        sx.showWaiting()
        var params = {
          email2: that.input.email2,
          token: localStorage.getItem('token')
        }
        var url = that.$store.state.baseurl + '/app/account/authcode'
        sx.request(
          url,
          params,
          function(result) {
            if (result.status === 'ok') {
              that.sendmail = true
              sx.hideWaiting()
              sx.toastSuccess('「連絡用メールアドレス 確認コードのご連絡」メールを送信しました。')
            }
          },
          function(result) {
            sx.login(
              url,
              params,
              function(result) {
                if (result.status === 'ok') {
                  that.sendmail = true
                  sx.hideWaiting()
                  sx.toastSuccess('「連絡用メールアドレス 確認コードのご連絡」メールを送信しました。')
                } else {
                  sx.toastSuccess(result.message)
                  console.log(result.message)
                }
              }
            )
          }
        )
        sx.hideWaiting()
      } else {
        sx.toastError('メールアドレスを入力してください！')
        console.log('A username and password must be present')
      }
    },
    save() {
      const that = this
      if (!sx.isNothingOrEmpty(that.input.email2) && !sx.isNothingOrEmpty(that.input.authcode)) {
        sx.showWaiting()
        var params = {
          email2: that.input.email2,
          code: that.input.authcode,
          token: localStorage.getItem('token')
        }
        var url = that.$store.state.baseurl + '/app/account/bind'
        sx.request(
          url,
          params,
          function(result) {
            if (result.status === 'ok') {
              sx.relogin(
                function() {
                  that.$store.state.userinfo.email2 = that.input.email2
                  localStorage.setItem('userinfo', JSON.stringify(that.$store.state.userinfo))
                  sx.hideWaiting()
                  sx.toastSuccess('連絡用メールアドレスを登録しました！')
                  that.$router.replace({ name: 'My' })
                }
              )
            }
          },
          function(result) {
            sx.login(
              url,
              params,
              function(result) {
                if (result.status === 'ok') {
                  sx.relogin(
                    function() {
                      that.$store.state.userinfo.email2 = that.input.email2
                      localStorage.setItem('userinfo', JSON.stringify(that.$store.state.userinfo))
                      sx.hideWaiting()
                      sx.toastSuccess('連絡用メールアドレスを登録しました！')
                      that.$router.replace({ name: 'My' })
                    }
                  )
                } else {
                  sx.toastSuccess(result.message)
                  console.log(result.message)
                }
              }
            )
            console.log('update failed')
          }
        )
        sx.hideWaiting()
      } else {
        sx.toastError('確認コードを入力してください！')
        console.log('A username and password must be present')
      }
    }
  }
}
</script>
<style scoped>
.main {
  padding:20px;
}
</style>
